// Livraison estimée de la fiche produit (spec calendrier §6.2). Sans calendrier (produit Orium,
// calendrier indisponible) : le calcul d'avant, clôture et week-ends sautés. Avec le calendrier
// d'Halluin : le traitement attend le premier jour OUVERT. Le transport compte toujours des jours
// ouvrés (lundi-vendredi). Tout se lit à l'heure de Paris, clôture comprise.
// Clôture par entrepôt (Benjamin, 29/09) : Halluin 12h00 — commandé avant 12h00, un produit à
// 0 jour part le jour même ; de 12h00 à 23h59, le lendemain. Les autres gardent 13h30.
const DEFAULT_CUTOFF = { hour: 13, minute: 30 }
const CUTOFFS = { HAL: { hour: 12, minute: 0 } }
const PARTS = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })

const cutoffFor = shipFrom => CUTOFFS[shipFrom] || DEFAULT_CUTOFF

function parisParts (date) {
  const p = Object.fromEntries(PARTS.formatToParts(date).map(x => [x.type, x.value]))
  return { day: `${p.year}-${p.month}-${p.day}`, hour: Number(p.hour), minute: Number(p.minute) }
}
const pad = n => String(n).padStart(2, '0')
const addDays = (day, n) => { const d = new Date(day + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10) }
const isWeekday = day => { const w = new Date(day + 'T00:00:00Z').getUTCDay(); return w >= 1 && w <= 5 }
const canProcess = (day, openDays) => (openDays ? openDays.includes(day) : isWeekday(day))

function processingDay (now, openDays, cutoff = DEFAULT_CUTOFF) {
  const { day, hour, minute } = parisParts(now)
  const afterCutoff = hour > cutoff.hour || (hour === cutoff.hour && minute >= cutoff.minute)
  let d = canProcess(day, openDays) && !afterCutoff ? day : addDays(day, 1)
  for (let i = 0; i < 60 && !canProcess(d, openDays); i++) d = addDays(d, 1)
  // Aucun jour ouvert trouvé dans la fenêtre de scan (calendrier vide, ou entièrement passé) :
  // calendrier inutilisable, traité comme indisponible (openDays = null).
  if (openDays && !canProcess(d, openDays)) return processingDay(now, null, cutoff)
  return d
}

function processingDate (now, openDays, cutoff) {
  return new Date(processingDay(now, openDays, cutoff) + 'T12:00:00Z')
}

function deliveryDate (now, weightKg, openDays, cutoff) {
  const needed = (weightKg || 0) < 25 ? 2 : 4
  let d = processingDay(now, openDays, cutoff)
  for (let added = 0; added < needed;) {
    d = addDays(d, 1)
    if (isWeekday(d)) added++
  }
  return new Date(d + 'T12:00:00Z')
}

// Heure de clôture (Paris) du prochain jour de traitement, en instant absolu.
function nextCutoff (now, openDays, cutoff = DEFAULT_CUTOFF) {
  const day = processingDay(now, openDays, cutoff)
  const probe = new Date(`${day}T${pad(cutoff.hour)}:${pad(cutoff.minute)}:00Z`)
  const { hour } = parisParts(probe)
  return new Date(probe.getTime() - (hour - cutoff.hour) * 3600 * 1000)
}

module.exports = { cutoffFor, deliveryDate, nextCutoff, processingDate }
